function generateUrlForStates(stateName) {
  return stateName.toLowerCase().replace(" ", "-");
}

module.exports = {
  generateUrlForStates,
};
